import React, { useState } from 'react';
import UserListView from './UserListView';
import { getEnhancedUserData } from '../../services/analyticsService';

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allUsers, setAllUsers] = useState([]);

  // Fetch real user data on component mount
  React.useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const userData = await getEnhancedUserData(1000); // Get up to 1000 users
        setAllUsers(userData);
        setUsers(userData);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleFilter = (filter) => {
    switch (filter) {
      case 'active':
        setUsers(allUsers.filter(user => {
          const lastActivity = user.lastActivity;
          if (!lastActivity) return false;
          const lastActivityDate = new Date(lastActivity);
          const cutoffDate = new Date();
          cutoffDate.setDate(cutoffDate.getDate() - 7); // Active in last 7 days
          return lastActivityDate >= cutoffDate;
        }));
        break;
      case 'paid':
        setUsers(allUsers.filter(user => user.journeyStage === 'paid'));
        break;
      case 'free':
        setUsers(allUsers.filter(user => user.journeyStage !== 'paid'));
        break;
      default:
        setUsers(allUsers);
    }
  };

  const handleSearch = (query) => {
    if (!query) {
      setUsers(allUsers);
      return;
    }
    const searchTerm = query.toLowerCase();
    setUsers(allUsers.filter(user =>
      user.name?.toLowerCase().includes(searchTerm) ||
      user.email?.toLowerCase().includes(searchTerm) ||
      user.tags?.some(tag => tag.toLowerCase().includes(searchTerm))
    ));
  };

  const handleSort = (column, direction) => {
    const sortedUsers = [...users].sort((a, b) => {
      let comparison = 0;
      switch (column) {
        case 'name':
          comparison = (a.name || '').localeCompare(b.name || '');
          break;
        case 'valueScore':
          comparison = (a.valueScore || 0) - (b.valueScore || 0);
          break;
        case 'resumesCreated':
          comparison = (a.resumesCreated || 0) - (b.resumesCreated || 0);
          break;
        case 'journeyStage':
          comparison = (a.journeyStage || '').localeCompare(b.journeyStage || '');
          break;
        default:
          comparison = 0;
      }
      return direction === 'asc' ? comparison : -comparison;
    });
    setUsers(sortedUsers);
  };

  const handleSendEmail = () => {
    // In a real app, this would open an email modal or make an API call
    console.log('Sending email to selected users');
  };

  const handleAddTags = () => {
    // In a real app, this would open a tag modal or make an API call
    console.log('Adding tags to selected users');
  };

  const handleExport = (userIds) => {
    // In a real app, this would generate and download a CSV
    console.log('Exporting users:', userIds);
  };

  return (
    <UserListView
      title="All Users"
      description={`Showing ${users.length} users`}
      users={users}
      loading={loading}
      onFilter={handleFilter}
      onSearch={handleSearch}
      onSort={handleSort}
      onSendEmail={handleSendEmail}
      onAddTags={handleAddTags}
      onExport={handleExport}
    />
  );
};

export default AllUsers; 